export enum HeaderStyle {
    Default = 1,
    Compact = 2,
    None = 3
}